/** Green → orange → red scale used to color-grade player form/points across the app. */
export function formAccentColor(t: number): string {
  const clamp = (value: number) => Math.min(1, Math.max(0, value))
  const lerp = (a: number, b: number, amount: number) => Math.round(a + (b - a) * amount)
  const hexToRgb = (hex: string): [number, number, number] => {
    const value = parseInt(hex.slice(1), 16)
    return [(value >> 16) & 255, (value >> 8) & 255, value & 255]
  }
  const rgbToHex = (rgb: [number, number, number]) =>
    `#${rgb.map((channel) => channel.toString(16).padStart(2, '0')).join('')}`

  const best = hexToRgb('#3fc989')
  const mid = hexToRgb('#f5a524')
  const worst = hexToRgb('#ea5a5f')
  const clamped = clamp(t)

  if (clamped <= 0.54) {
    const amount = clamped / 0.54
    return rgbToHex([lerp(best[0], mid[0], amount), lerp(best[1], mid[1], amount), lerp(best[2], mid[2], amount)])
  }

  const amount = (clamped - 0.54) / 0.46
  return rgbToHex([lerp(mid[0], worst[0], amount), lerp(mid[1], worst[1], amount), lerp(mid[2], worst[2], amount)])
}

/** Per-match points color: 0 pnt or less → red, 10+ pnt → green, same scale as formAccentColor. */
export function pointsAccentColor(points: number): string {
  const normalized = Math.min(1, Math.max(0, points / 10))
  return formAccentColor(1 - normalized)
}
